import { i18n } from 'i18n'

export type ErrorType = 'unknown' | 'item-not-found' | 'generation-failed' | 'bad-configuration'

export function getErrorTitle(error: ErrorType | undefined) {
  switch (error) {
    case 'item-not-found':
      return i18n('error.ItemNotFound')
    case 'generation-failed':
      return i18n('error.GenerationFailed')
    case 'bad-configuration':
      return i18n('error.BadConfiguration')
    case 'unknown':
    default:
      return i18n('error.ErrorOccurred')
  }
}

export function getErrorDescription(error: ErrorType | undefined) {
  switch (error) {
    case 'item-not-found':
    case 'generation-failed':
    case 'bad-configuration':
      return i18n('error.UnfortunatelyYouCannotTryThisThingOnYet')
    case 'unknown':
    default:
      return i18n('error.SomethingWentWrongTryAgainLater')
  }
}
